import React from 'react';
import { Control } from 'react-hook-form';
import DefaultButton from 'components/Utils/NewDefaultButton';
import { ISSUE_TYPES } from 'components/HealthRecords/AppointmentNotes/NewAppointmentNote/constants';
import Icon from 'components/Utils/NewIcon';
import DefaultTextField from 'components/Utils/DefaultTextField';
import DefaultAutoComplete from 'components/Utils/DefaultAutoComplete';
import DefaultDatePicker from 'components/Utils/DefaultDatePicker';
import DefaultSelectField from 'components/Utils/DefaultSelectField';

export const TopBar = ({
  title,
  onClear,
  onClose,
  children,
  showCloseButton,
}: {
  title: string;
  onClear?: () => void;
  onClose?: () => void;
  children?: React.ReactNode;
  showCloseButton?: boolean;
}) => (
  <div className="row top-bar">
    <div className="small-title delete">
      {showCloseButton !== false && <Icon src="xmark" onClick={onClose} />}
      <span className="title-content">{title}</span>
      {onClear !== undefined && (
        <span onClick={onClear} className="clear-loaded-item">
          Clear all
        </span>
      )}
    </div>
    {children}
  </div>
);

export const NameField = ({
  loading,
  autoComplete,
  control,
}: {
  loading?: boolean;
  autoComplete?: any[];
  control: Control<any>;
}) => {
  if (autoComplete)
    return <AutoCompleteField loading={loading} autoComplete={autoComplete} control={control} />;

  return (
    <DefaultTextField
      name="name"
      control={control}
      label="Name"
      disabled={loading}
      style={{ width: 'calc(100% - 220px)' }}
    />
  );
};

const AutoCompleteField = ({
  loading,
  autoComplete,
  control,
}: {
  loading?: boolean;
  autoComplete: any[];
  control: Control<any>;
}) => {
  return (
    <DefaultAutoComplete
      name="name"
      id="name-field"
      control={control}
      placeholder="Name"
      style={{ width: '100%', marginTop: '0' }}
      dataSource={autoComplete}
    />
  );
};

export const DateField = ({ date, control }: { date?: boolean; control: Control<any> }) => {
  return date ? (
    <DefaultDatePicker name="date" control={control} label="Date" style={{ marginLeft: '20px' }} />
  ) : (
    <div key="empty-date" />
  );
};

export const NotesField = ({
  loading,
  style = {},
  control,
}: {
  loading?: boolean;
  style?: React.CSSProperties;
  control: Control<any>;
}) => (
  <DefaultTextField
    name="notes"
    control={control}
    label="Notes"
    disabled={loading}
    style={{ width: 'calc(100% - 220px)', ...style }}
  />
);

export const IssueTypeField = ({
  loading,
  style = {},
  control,
}: {
  loading?: boolean;
  style?: React.CSSProperties;
  control: Control<any>;
}) => (
  <DefaultSelectField
    name="issue_type"
    control={control}
    label="Issue Type"
    style={{ width: '180px', marginRight: '20px', ...style }}
    inputs={Object.values(ISSUE_TYPES)}
    disabled={loading}
  />
);

export const EditAddButton = ({
  isEditing,
  title,
  isEditAddValid,
  onAddItem,
}: {
  isEditing: boolean;
  title?: string;
  isEditAddValid: boolean;
  onAddItem: () => void;
}) => (
  <DefaultButton
    key="editAdd"
    name={(isEditing ? 'Edit' : 'Add') + ` ${title || ''}`}
    style={{ width: '200px' }}
    disabled={!isEditAddValid}
    onClick={onAddItem}
    id="edit-add"
  />
);

export const DeleteButton = ({
  isEditing,
  onDeleteItem,
  style = {},
}: {
  isEditing: boolean;
  onDeleteItem: () => void;
  style?: React.CSSProperties;
}) => (
  <DefaultButton
    key="remove"
    name="Remove"
    className="red"
    onClick={onDeleteItem}
    hide={!isEditing}
    style={{ width: '200px', marginTop: '10px', ...style }}
  />
);
